import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import IKiosk from '../../interfaces/IKiosk'
import IKioskReason from '../../interfaces/IKioskReason'
import {
  SearchRequest,
  KioskCreateRequest
} from '../../services/api/interfaces/ApiRequest'
import {
  kioskList,
  kioskCreate,
  kioskReasonList
} from '../../services/api'

interface KioskContextState extends BaseContextState {
  kiosk: IKiosk | null,
  kiosks: Array<IKiosk> | null,
  kioskReasons: Array<IKioskReason> | null
}

export interface KioskContextData extends KioskContextState {
  resetErrors: Function,

  requestKioskList: (args: SearchRequest) => void,
  requestKioskCreate: (args: KioskCreateRequest) => Promise<IKiosk | null>
  requestKioskReasonList: (args: SearchRequest) => Promise<any>
}

// Create context
const { Provider, Consumer } = createContext({} as KioskContextData)

// Export consumer
export const KioskConsumer = Consumer

export class KioskProvider extends BaseContextProvider {
  state: KioskContextState = {
    kiosk: null,
    kiosks: null,
    kioskReasons: null
  }

  /**
   * Make api request for kiosk list
   * 
   * @param {SearchRequest} payload 
   */
  requestKioskList = (payload: SearchRequest) => {
    this.setState({
      fetching: true,
      error: null
    }, async () => {
      const response = await kioskList(payload)

      // Process our response
      this.processResponse(response, { 
        paginate: {
          destination: 'kiosks'
        },
      })
    })
  }

  /**
   * Make api request for kiosk create
   * 
   * @param {KioskCreateRequest} payload 
   */
  requestKioskCreate = (payload: KioskCreateRequest):  Promise<IKiosk | null> => {
    return new Promise((resolve, reject) => {
      this.setState({
        fetching: true,
        error: null
      }, async () => {
        const response = await kioskCreate(payload)
  
        // Process our response
        this.processResponse(response, { 
          mappings: {
            destination: 'kiosk'
          },
        })

        if (this.state.success) {
          resolve(this.state.kiosk)
        } else {
          reject(this.state.error)
        }
      })
    })
  }

  /**
   * Make api request for kiosk reason list
   * 
   * @param {SearchRequest} payload 
   */
   requestKioskReasonList = (payload: SearchRequest) => {
    return new Promise((resolve, reject) => {
      this.setState({
        fetching: true,
        error: null
      }, async () => {
        const response = await kioskReasonList(payload)
  
        // Process our response
        this.processResponse(response, { 
          paginate: {
            destination: 'kioskReasons'
          },
        })

        if (this.state.success) {
          resolve(this.state.kioskReasons)
        } else {
          reject(this.state.error)
        }
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestKioskList: this.requestKioskList,
          requestKioskCreate: this.requestKioskCreate,
          requestKioskReasonList: this.requestKioskReasonList
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
